/**
 * Text helpers shared by the editorial QA, the research checks and the web app's Atelier.
 * No Node dependency: this file (with numbers.ts, families.ts and ../images/direction.ts)
 * is imported by the browser.
 */
export function normalizeText(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

const words = (text: string): string[] => normalizeText(text).split(" ").filter(Boolean);

/** Share of distinct words two texts have in common, over the larger set. */
export function sharedWordShare(a: string, b: string): number {
  const left = new Set(words(a));
  const right = new Set(words(b));
  const size = Math.max(left.size, right.size);
  if (size === 0) return 0;
  let shared = 0;
  for (const word of left) if (right.has(word)) shared += 1;
  return shared / size;
}
